'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _zhCN = require('iview/dist/locale/zh-CN');

var _zhCN2 = _interopRequireDefault(_zhCN);

var _enUS = require('iview/dist/locale/en-US');

var _enUS2 = _interopRequireDefault(_enUS);

var _tipsConf = require('@/config/tips-conf');

var _tipsConf2 = _interopRequireDefault(_tipsConf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  zh_CN: (0, _assign2.default)(_tipsConf2.default.zh_CN, _zhCN2.default),
  zy_CN: (0, _assign2.default)(_tipsConf2.default.zy_CN, _zhCN2.default),
  en_US: _enUS2.default //Object.assign(i18nTip.en_US, en)
};